







































import { Vue, Component, PropSync, Prop } from "vue-property-decorator";
import { ApkService } from "./apk.service";
import { ApkDetectionNetworkItem } from "./apk.interface";
import { Table } from "element-ui";
@Component
export default class ApkDetectionNetworkDialog extends Vue {
  @PropSync("visible") syncVisible: boolean;
  @Prop() detectionId: string;

  list: ApkDetectionNetworkItem[] = [];
  loading = 0;

  async fetch() {
    if (!this.list.length) {
      this.loading++;
      if (this.$route.query.type === "log") {
        this.list = await ApkService.getApkDetectionNetworkDetailLog(
          this.detectionId
        );
      } else {
        this.list = await ApkService.getApkDetectionNetworkDetail(
          this.detectionId
        );
      }
      this.loading--;
    }
  }

  getRowClass(tablePayload: any) {
    const row: ApkDetectionNetworkItem = tablePayload.row;
    return row.isCrossOrigin ? "is-danger" : "";
  }
}
